import React from "react";

const handleAbmWithdrawals = (props) => {
  const options = [
    {
      text: 'What are ABM withdrawals?',
      handler: props.actionProvider.handleAbmWithdrawals1,
      id: 1,
    },
    {
      text: 'Help, I’m concerned about something that happened at an Automated Bank Machine (ABM).',
      handler: props.actionProvider.handleAbmWithdrawals2,
      id: 2
    },
    {
      text: 'The Security of ABM withdrawals',
      handler: props.actionProvider.handleAbmWithdrawals3,
      id: 3
    },
    {
      text: 'How ABM withdrawals works?',
      handler: props.actionProvider.handleAbmWithdrawals4,
      id: 4
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container requestmoney-products'>{optionsMarkup}</div>;
};

export default handleAbmWithdrawals;